import React, { useContext, useMemo } from 'react';

import Button from 'components/shared/Button';
import { ShufflerContext } from './Shuffler';

import type { ShufflerContextType } from './Shuffler';
import { capitalize } from 'lodash';

type ShufflerFilterButtonProps = {
  filter: string;
};

function ShufflerFilterButton(props: ShufflerFilterButtonProps) {
  const { filter } = props;
  const { byFilter, metalabels } = useContext(ShufflerContext) as ShufflerContextType;

  const [value, label] = filter.split(':');

  const metalabel = useMemo(() => {
    let lbl;

    if (label.indexOf('meta--') === 0) {
      lbl = label
        .replace(/^meta--/, '')
        .split(':')
        .shift();
    }

    return lbl;
  }, [label]);

  const showLabel = useMemo(() => {
    const show = metalabel && metalabel in metalabels ? metalabels[metalabel] : label;
    return capitalize(show);
  }, [label, metalabel, metalabels]);

  const showValue = value !== 'true' ? ` : ${value}` : '';

  const dataset = useMemo(() => {
    const ret: Record<string, string> = {
      groupname: label,
      value,
    };

    if (metalabel) {
      ret.meta = metalabel;
    }

    return ret;
  }, [label, metalabel, value]);

  return (
    <div className="shuffler-filter-button">
      {showLabel}
      {showValue}
      <Button
        type="icon"
        icon="times"
        appearance="primary"
        a11yText="Remove Filter"
        className="shuffler-filter-remove"
        onClick={(e) => byFilter(e.currentTarget)}
        dataset={dataset}
      />
    </div>
  );
}

export default ShufflerFilterButton;
